<app-status-sidebar
  [itemId]="taskId()"
  [config]="taskConfig"
  [service]="taskService"
  [updateMethod]="'updateTask'"
  [getDetailsMethod]="'getSingleTask'"
  [refreshTrigger]="effectiveRefreshTrigger()"
></app-status-sidebar>
